import { FrequencyUnit, ScheduleFrequency } from '@griply/types';

import { Frequency } from '../lib/rrule';

export const EVERY_DAY_RRULE = 'RRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR,SA,SU';

export const MONTH_ORDINALS: readonly number[] = [1, 2, 3, 4, 5, -1];

export const MONTH_DAYS: readonly number[] = Array.from(
  { length: 31 },
  (_, index) => index + 1,
);

export const MONTHS: readonly number[] = Array.from(
  { length: 12 },
  (_, index) => index + 1,
);

export const defaultFrequency: ScheduleFrequency = {
  count: 1,
  unit: FrequencyUnit.Week,
  label: null,
};

export const frequencyToWeekAdjustmentsMap: Record<Frequency, number> = {
  [Frequency.SECONDLY]: -1,
  [Frequency.MINUTELY]: -1,
  [Frequency.HOURLY]: -1,
  [Frequency.DAILY]: -1,
  [Frequency.WEEKLY]: -1,
  [Frequency.MONTHLY]: -4,
  [Frequency.YEARLY]: -52,
};
